export const faqItems = [
  {
    title: 'Who can apply for a grants?',
    description:
      'Anyone can apply as long as their project benefits the Beam ecosystem.',
  },
  {
    title: 'How do I apply?',
    description:
      'Simply fill out the application form with all the required information.',
  },
  {
    title: 'How is funding distributed?',
    description:
      'In installments based on milestone completion with regular progress check-ins.',
  },
  {
    title: 'Who reviews applications?',
    description:
      'The Beam Foundation in collaboration with the Grant Committee.',
  },
  {
    title: 'What reporting is required?',
    description:
      'This depends on the agreements and acceptance criteria that were agreed upon in the legal agreement.',
  },
  {
    title: 'Are grant details public?',
    description:
      'Yes, all approved or rejected grants are listed publicly including grantee, project summary, amount, and status.',
  },
  {
    title: 'Do I need an MVP (minimum viable product)?',
    description:
      'Not necessarily, but applications that include an MVP or similar project demonstration may have a higher chance of succeeding.',
  },
  {
    title: 'What types of projects qualify?',
    description:
      'Technology, content, infrastructure, research, or community initiatives that add value to the Beam ecosystem.',
  },
];
